import { AxiosResponse } from 'axios';
import { api } from './api/api';

export async function findAllMineralSubstances<T>(language: string) {
  const response: AxiosResponse<T> = await api.get(
    `/subst_mineral/?lang=${language}`,
  );

  return response;
}

export async function findMineralSubstances<T>(id: string, language: string) {
  const response: AxiosResponse<T> = await api.get(
    `/subst_mineral/?id=${id}&lang=${language}`,
  );

  return response;
}
